import { render, staticRenderFns } from "./Users-Accounts.vue?vue&type=template&id=55a0b605"
import script from "./Users-Accounts.vue?vue&type=script&lang=js"
export * from "./Users-Accounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports